import { Injectable } from '@angular/core';
import { Asistente } from '../model/asistente';
import { Votacion } from '../model/votacion';
import { HttpClient } from '@angular/common/http';
import { ClienteSesion } from '../model/cliente-sesion';
import { share } from 'rxjs/operators';
import { ParametrosConst } from '../util/parametrosConst';
import { AppConfigService } from 'src/app/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class VotacionService {

  private localStorageService: any;
  private url_acceder = '';
  private url_validarIdentidad = '';
  private url_obtenerPreguntaActiva = '';
  private url_obtenerPreguntas = '';
  private url_obtenerOpciones = '';
  private url_generarVotacion = '';
  private url_generarVotacionRemota = '';
  private url_obtenerNombreFondo = '';
  private url_obtenerDatosAsamblea = '';
  private url_obtenerParametroAcceso = '';

  private url_editarVotacion = '';
  private currentSession: ClienteSesion = null;

  constructor(
    private _http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.loadConfig();
    this.localStorageService = localStorage;
    this.currentSession = this.loadSessionData();
  }

  loadConfig() {
    const conf = this.appConfigService.getConfig();
    this.url_acceder = conf.apiEndpointClient + '/validation/ingreso';
    this.url_validarIdentidad = conf.apiEndpointClient + '/user/validarVotante/';
    this.url_obtenerPreguntaActiva = conf.apiEndpointClient + '/pregunta/traerPregunta';
    this.url_obtenerPreguntas = conf.apiEndpointClient + '/pregunta/traerPreguntas';
    this.url_obtenerOpciones = conf.apiEndpointClient + '/pregunta/traerOpcionesPregunta';
    this.url_generarVotacion = conf.apiEndpointClient + '/user/guardarVoto';
    this.url_generarVotacionRemota = conf.apiEndpointClient + '/user/guardarVotos';
    this.url_obtenerNombreFondo = conf.apiEndpointClient + '/pregunta/obtenerNombreFondo';
    this.url_obtenerDatosAsamblea = conf.apiEndpointClient + '/user/datosAsamblea';
    this.url_editarVotacion = conf.apiEndpointClient + '/user/editarVoto';
    this.url_obtenerParametroAcceso = conf.apiEndpointClient + '/pregunta/traerParametros';
  }

  obtenerDatosAsamblea(idAsamblea: number, token: string) {
    return this._http.post(this.url_obtenerDatosAsamblea, {
      nombre: 'idAsamblea',
      valor: idAsamblea,
      token: token
    }).toPromise();
  }

  verificarUsuario(_asistente: Asistente) {
    return this._http.post(this.url_acceder, {
      numeroDocumento: _asistente.numeroDocumento,
      idAsamblea: _asistente.idAsamblea
    }).pipe(share());
  }

  validarIdentidad(_asistente: Asistente) {
    return this._http.post(this.url_validarIdentidad, {
      idAsamblea: _asistente.idAsamblea,
      numeroDocumento: _asistente.numeroDocumento,
      token: localStorage.getItem(ParametrosConst.TOKEN_CLIENTE)
    }).toPromise();
  }

  obtenerPreguntaActiva(_idAsamblea: number, _idAsistente: number, _idFoto: number, tipoAsistencia: string, _tipoVoto: string) {
    let edicionVoto = localStorage.getItem(ParametrosConst.EDICION_VOTO) == 'S' ? true : false;
    return this._http.post(tipoAsistencia === 'M' || tipoAsistencia === 'H' || edicionVoto? this.url_obtenerPreguntaActiva : this.url_obtenerPreguntas,
      {
        idAsamblea: _idAsamblea,
        idAsistente: _idAsistente,
        idFoto: _idFoto,
        token: this.getCurrentToken(),
        tipoVoto: _tipoVoto
      }).toPromise();
    // return this._http.get(this.url_obtenerPreguntaActiva ).toPromise();
  }

  obtenerNombreFondo(_idAsamblea: number) {
    return this._http.post(this.url_obtenerNombreFondo,
      {
        nombre: 'idAsamblea',
        valor: _idAsamblea,
        token: this.getCurrentToken()
      }).toPromise();
  }

  obtenerParametroAcceso(_tipoParametro: string) {
    return this._http.post(this.url_obtenerParametroAcceso, {nombre: '', valor: _tipoParametro, token: this.getCurrentToken()}).toPromise();
  }

  obtenerOpciones(idPregunta: number, idAsamblea: number, idFoto: number) {
    return this._http.post(this.url_obtenerOpciones, { valor: idPregunta, nombre: '', token: this.getCurrentToken(), idAsamblea: idAsamblea, idFoto : idFoto }).toPromise();
    // return this._http.get(this.url_obtenerOpciones).toPromise();
  }

  generarVotacion(_votacion: Votacion) {
    return this._http.post(this.url_generarVotacion, Object.assign(_votacion, { token: this.getCurrentToken() })).toPromise();
    // return this._http.get(this.url_generarVotacion ).toPromise();
  }

  generarVotacionRemota(listaVotacion: Votacion[]) {
    listaVotacion.forEach(voto => {
      voto.token = this.getCurrentToken();
    });
    return this._http.post(this.url_generarVotacionRemota, Object.assign(listaVotacion)).toPromise();
  }

  setCurrentSession(session: ClienteSesion): void {
    this.currentSession = session;
    this.localStorageService.setItem(ParametrosConst.USUARIO_CLIENTE, JSON.stringify(session));
  }

  loadSessionData(): ClienteSesion {
    const sessionStr = this.localStorageService.getItem(ParametrosConst.USUARIO_CLIENTE);
    return (sessionStr) ? JSON.parse(sessionStr) as ClienteSesion : null;
  }

  getCurrentSession(): ClienteSesion {
    return this.currentSession;
  }

  private removeCurrentSession(): void {
    this.localStorageService.removeItem(ParametrosConst.USUARIO_CLIENTE);
    this.localStorageService.removeItem(ParametrosConst.TOKEN_CLIENTE);
    this.localStorageService.removeItem(ParametrosConst.USUARIO_MENU);
    this.currentSession = null;
  }

  getCurrentUser(): Asistente {
    const session: ClienteSesion = this.getCurrentSession();
    return (session && session.asistente) ? session.asistente : null;
  }

  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null);
  }

  getCurrentToken(): string {
    const session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  }

  logout(): void {
    this.removeCurrentSession();
    // this.router.navigate(['/validacion']);
  }


  votacionHistorico(_idAsamblea: number, _idFoto: number) {
    return this._http.post(this.url_editarVotacion,
      {
        idAsamblea: _idAsamblea,
        idFoto: _idFoto,
        token: this.getCurrentToken()
      }).toPromise();
    // return this._http.get(this.url_obtenerPreguntaActiva ).toPromise();
  }

}
